// 詢問第三方 API
window.askOpenAI = function (message, needSetQuestion = true, callback) {
    let url = $('meta[name="third-party-chat-url"]').attr("content");
    let useVoice = $('meta[name="use-voice"]').attr("content");
    let voiceLang = $('meta[name="voice-lang"]').attr("content");
    let conversationId =
        $('meta[name="third-party-conversation-id"]').attr("content") ||
        window.thirdPartyConversationId ||
        "";

    if (needSetQuestion) {
        setQuestionContent(message);
    }

    let payload = {
        message: message,
    };

    if (conversationId) {
        payload.conversation_id = conversationId;
    }

    $.ajax({
        url: url,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(payload),
        success: function (data) {
            let newConversationId = data.conversation_id || "";
            if (newConversationId) {
                window.thirdPartyConversationId = newConversationId;
                $('meta[name="third-party-conversation-id"]').attr(
                    "content",
                    newConversationId,
                );
            }

            let messageText = data.message || "";
            let messageHtml = textToHtml(messageText);

            saveHistory(message, messageHtml, useVoice, voiceLang, function (historyId) {
                callback(removeHtmlTags(messageText), function () {
                    setAnswerContent(messageHtml, historyId);
                });
            });
        },
        error: function (xhr, status, error) {
            console.error("third-party api error", { xhr, status, error });
            $(".rd-loading-content").hide();
            enableButton();
        },
    });

    $('meta[name="use-voice"]').attr("content", 0);
};

window.removeHtmlTags = function (str) {
    return str.replace(/<\/?[^>]+(>|$)/g, "");
};

window.setQuestionContent = function (content, needLoading = true) {
    $("#rd-input-text").text("");

    $("#rd-card").hide();
    $("#rd-hello").hide();

    $("#msgHistory").append(`
        <div class="right-item">${content}</div>
    `);

    if (needLoading) {
        $("#msgHistory").append(`
            <div class="left-item rd-loading-content">
                <div class="did-loading">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                </div>
            </div>
        `);
    }

    scrollQuestion();
};

window.setAnswerContent = function (content, id) {
    $("#msgHistory").append(`
        <div class="left-item">
            ${content}
            <div class="comment-tool">
                <div class="good rd-click-review" data-id="${id}" data-type="2"></div>
                <div class="none-good rd-click-review" data-id="${id}" data-type="3"></div>
            </div>
        </div>
    `);

    $("#msgHistory").find("a").attr("target", "_blank").data("id", id);

    $(".rd-loading-content").hide();
    scrollQuestion();
    reviewEvent();
    trackEvent();
};

window.scrollQuestion = function () {
    gsap.to("#rd-did-content", {
        duration: 1,
        scrollTo: {
            y: $("#msgHistory").find(".right-item").last(),
            offsetY: 0,
        },
    });
};

function reviewEvent() {
    $(".rd-click-review")
        .unbind()
        .on("click", function () {
            let _this = $(this);
            let type = _this.data("type");
            let history_id = _this.data("id");

            $.ajax({
                method: "POST",
                url: $('meta[name="review"]').attr("content"),
                data: { history_id: history_id, type: type },
                cache: false,
                success: function () {
                    _this
                        .closest(".comment-tool")
                        .find(".rd-click-review")
                        .removeClass("now");
                    _this.addClass("now");
                },
            });
        });
}

function trackEvent() {
    $("#msgHistory")
        .find("a")
        .unbind()
        .on("click", function () {
            let _this = $(this);
            let history_id = _this.data("id");
            let link = $(this).attr("href");

            $.ajax({
                method: "POST",
                url: $('meta[name="track"]').attr("content"),
                data: { history_id: history_id, link: link },
                cache: false,
            });
        });
}

function saveHistory(question, answer, useVoice, voiceLang, callback) {
    $.ajax({
        url: $('meta[name="save-history"]').attr("content"),
        method: "POST",
        data: {
            question: question,
            answer: answer,
            chat_id: $('meta[name="chat-id"]').attr("content"),
            use_voice: useVoice,
            voice_lang: voiceLang,
        },
        success: function (data) {
            callback(data.history_id);
        },
        error: function () {
            callback("");
        },
    });
}

function textToHtml(text) {
    const escaped = String(text || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");

    return escaped.replace(/\n/g, "<br>");
}




